// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion dt').length > 0) {
		$(".js-accordion dt").click(function () {
			$(this).next("dd").slideToggle();
			$(this).toggleClass("is-open");
		});
	}
});

// //// FLOATING START ////
// js-target（= p-fv）の「半分」が画面外に出たら表示する
// （閉じるで非表示、js-targetが見える状態に戻れば再許可）
jQuery(function ($) {
	var floating = document.querySelector(".l-floating");
	var pageup = document.getElementById("pageup");
	if (!floating) return;

	var floatingClose = floating.querySelector(".l-floating__close");
	var fv = document.querySelector(".js-target");

	var dismissed = false;
	var scrolledOnce = false;

	var hide = function () {
		floating.classList.add("is-hidden");
		if (pageup) {
			$(pageup).fadeOut();
		}
	};

	var show = function () {
		if (dismissed) return;
		floating.classList.remove("is-hidden");
		if (pageup) {
			$(pageup).fadeIn();
		}
	};

	hide();

	if (floatingClose) {
		floatingClose.addEventListener("click", function () {
			// dismissed = true;
			// hide();
			floating.classList.add('removed', 'is-hidden');
		});
	}

	if (!fv) return;

	var update = function () {
		// 初期表示は非表示のまま
		if (!scrolledOnce) {
			hide();
			return;
		}

		var rect = fv.getBoundingClientRect();
		// js-target（= p-fv）の「半分」が画面上から外れたら表示
		//（要素の上端が -高さ/2 を超えたタイミング）
		var fvHeight = rect.height || fv.offsetHeight || 0;
		var fvHalfOut = fvHeight > 0 ? rect.top <= -(fvHeight / 2) : false;

		if (!fvHalfOut) {
			// js-target がまだ半分も外れていないなら閉じる状態をリセット
			dismissed = false;
			hide();
			return;
		}

		show();
	};

	var ticking = false;
	var onScroll = function () {
		if (ticking) return;
		ticking = true;

		window.requestAnimationFrame(function () {
			ticking = false;
			scrolledOnce = true;
			update();
		});
	};

	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll);

	update();
});
// //// FLOATING END ////


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.l-hamburger').length > 0) {
		$('.l-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is_open');
				nav.removeClass('is_close');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.l-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.l-hamburger:visible').length > 0) {
				$('.l-hamburger').click();
			}
		});
	}
});

// ページトップボタンの表示 // Display the page top button
jQuery(function ($) {

	if ($('#pageup').length > 0) {
		var topBtn = $('#pageup');
		// topBtn.css("display", "none");
		// //スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		// $(window).scroll(function () {
		// 	if ($(this).scrollTop() > 100) {
		// 		topBtn.fadeIn();
		// 	} else {
		// 		topBtn.fadeOut();
		// 	}
		// });
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});

document.addEventListener('DOMContentLoaded', function() {

	// プラン表の補足情報
	if (document.querySelector('.js-info-toggle[data-info]')) {
		try {
			document.querySelectorAll('.js-info-toggle[data-info]').forEach(toggle => {

				// モーダル開閉（トグルボタン）
				toggle.addEventListener('click', function(e) {
					const infoId = e.target.dataset.info;
					if (!infoId) {
						throw new Error('トグルボタンにdata-info属性がありません');
					}
					const modal = document.querySelector(`.js-info-modal[data-info="${infoId}"]`);
					if (!modal) {
						throw new Error('表示するモーダルがありません');
					}

					if (modal.classList.contains('is-show')) {
						modal.classList.remove('is-show');
					} else {
						document.querySelectorAll('.js-info-modal.is-show').forEach(openModal => {
							openModal.classList.remove('is-show');
						})
						modal.classList.add('is-show');
					}
				})
				
				// モーダルクローズ（閉じるボタン）
				document.querySelectorAll('.js-info-modal .js-info-modal-close').forEach(btn => {
					btn.addEventListener('click', function(e) {
						const modal = e.target.closest('.js-info-modal[data-info]');
						if (!modal) {
							throw new Error('クローズするモーダルがありません');
						}
						modal.classList.remove('is-show');
					})
				})
			})
		} catch(err) {
			console.error(err);
		}
	}
})